<div class="retail-place" data-qa-block="retail-place">
  <div class="wrapper">
    <div class="retail-place__icon">
      <div class="pointsale">
        <svg-icon key="pointsale"></svg-icon>
      </div>
    </div>
    <div class="retail-place__content">
      <p class="retail-place__title" data-qa="retail-place-name">{{ retailPlace.title }}</p>
      <span class="grey-text retail-place__address" data-qa="retail-place-address">{{
        retailPlace.address
      }}</span>
    </div>

    <div class="retail-place__counter">
      <span data-qa="kkms-count">{{ retailPlace.kkms.length }}</span>
    </div>

    <div
      class="retail-place__arrow"
      (click)="showKkms(); $event.stopPropagation()"
      data-qa-button="toggle-kkms-visibility"
    >
      <svg-icon [key]="displayKkms ? 'expand-less' : 'expand-more'" class="grey-icon"></svg-icon>
    </div>
  </div>

  <div *ngIf="displayKkms" data-qa-block="kkms-list">
    <ng-container *ngFor="let kkm of retailPlace.kkms">
      <tax-cto-kkm [kkm]="kkm" [contract]="contract"> </tax-cto-kkm>
    </ng-container>
  </div>
</div>
